import intersectionWith from 'lodash/intersectionWith'

import usePatientConsents from '@shared/hooks/src/usePatientConsents'
import { useMe } from '@shared/providers/src/MeProvider'
import { UserSettingName } from '@shared/utils'

export function useConsentsDone() {
  const me = useMe()

  const { data: requiredConsents } = usePatientConsents(me.id, { all: false })

  return (
    intersectionWith(
      requiredConsents,
      [
        UserSettingName.Initials,
        UserSettingName.AllowSharingHealthData,
        UserSettingName.AcceptTermsOfService,
        UserSettingName.AcceptPrivacyPolicy,
        UserSettingName.AcceptTelehealthConsent,
      ],
      (consent, name) => consent.name === name
    ).length === 0
  )
}
